import { useRouter } from "next/compat/router";
import { pathTranslator, useToggle } from "../../../utils/language";
import { List } from "../../Listbox/Listbox";
import styles from "./LanguageToggle.module.scss";
import { Post } from "@/wp/types/client";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";

export const LanguageToggle = ({
  post,
  addWrapper = false,
  extraClass = "",
}: {
  post: Post;
  hide?: boolean;
  addWrapper?: boolean;
  extraClass?: string;
}) => {
  const router = useRouter();
  const { toggle, setToggle } = useToggle();
  const availableTranslations = pathTranslator(post);
  const showLanguageToggle = availableTranslations.length > 0;
  const { getIcon } = useGlobalContext();

  const onLanguagePick = (e: string) => {
    if (availableTranslations.length > 0) {
      document.cookie = `NEXT_LOCALE=${e}; path=/`;
      setToggle(e);
    }
  };

  const ListJSX = (
    <List
      selected={toggle}
      availableTranslations={availableTranslations}
      setSelected={onLanguagePick}
      items={
        router?.locales?.map((l) => {
          return { label: l.toUpperCase(), value: l };
        }) ?? []
      }
      disableDropdown={availableTranslations.length < 1 ? true : false}
      closeOnSelection
      prefixIcon={
        <CustomSVG
          src={getIcon("globe")}
          wrapper={"span"}
          width={18}
          height={18}
          className="is-flex"
        />
      }
    />
  );

  return (
    <>
      {showLanguageToggle &&
        (addWrapper ? (
          <div
            className={`language-wrapper ${styles["language-wrapper"]} ${extraClass}`}
          >
            {ListJSX}
          </div>
        ) : (
          ListJSX
        ))}
    </>
  );
};
